import React from 'react';
import { Grid, ShimmerImage } from '@pitchero/react-ui';

const PhotosLoadingState = () => (
  <Grid preset="gallery">
    <ShimmerImage preset="card" />
    <ShimmerImage preset="card" />
    <ShimmerImage preset="card" />
    <ShimmerImage preset="card" />
    <ShimmerImage preset="card" />
    <ShimmerImage preset="card" />
    <ShimmerImage preset="card" />
    <ShimmerImage preset="card" />
  </Grid>
);

export default PhotosLoadingState;
